import { promptHierarchyLevels } from '@/mocks/lessonPlan';

export interface ProcedureStep {
  id: string;
  stepTitle: string;
  educatorAction: string;
  studentExpectation: string;
  promptLevel: string;
}

interface ProcedureStepRowProps {
  step: ProcedureStep;
  index: number;
  onChange: (step: ProcedureStep) => void;
  onRemove: () => void;
  stepNumberLabel: string;
  titlePlaceholder?: string;
  educatorPlaceholder?: string;
  studentPlaceholder?: string;
  promptLabel?: string;
  removeLabel?: string;
}

export default function ProcedureStepRow({
  step,
  index,
  onChange,
  onRemove,
  stepNumberLabel,
  titlePlaceholder,
  educatorPlaceholder,
  studentPlaceholder,
  promptLabel,
  removeLabel,
}: ProcedureStepRowProps) {
  const handleChange = (field: keyof ProcedureStep, value: string) => {
    onChange({ ...step, [field]: value });
  };

  return (
    <div className="bg-background-100/70 border border-background-200 rounded-xl p-4 relative group">
      <div className="flex items-center justify-between mb-3">
        <span className="font-heading font-700 text-sm text-foreground-800">
          {stepNumberLabel.replace('{{number}}', String(index + 1))}
        </span>
        <button
          type="button"
          onClick={onRemove}
          className="w-7 h-7 flex items-center justify-center rounded-lg text-foreground-400 hover:text-semantic-error hover:bg-semantic-error/10 transition-colors cursor-pointer opacity-0 group-hover:opacity-100"
          title={removeLabel}
        >
          <i className="ri-delete-bin-line text-sm" />
        </button>
      </div>

      <div className="space-y-3">
        <div>
          <input
            type="text"
            value={step.stepTitle}
            onChange={(e) => handleChange('stepTitle', e.target.value)}
            placeholder={titlePlaceholder}
            className="w-full xl-input text-sm"
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          <div>
            <textarea
              value={step.educatorAction}
              onChange={(e) => handleChange('educatorAction', e.target.value)}
              placeholder={educatorPlaceholder}
              rows={3}
              className="w-full xl-input text-sm resize-none"
            />
          </div>
          <div>
            <textarea
              value={step.studentExpectation}
              onChange={(e) => handleChange('studentExpectation', e.target.value)}
              placeholder={studentPlaceholder}
              rows={3}
              className="w-full xl-input text-sm resize-none"
            />
          </div>
        </div>

        <div>
          <span className="text-xs font-label font-medium text-foreground-500 mb-1.5 block">{promptLabel}</span>
          <select
            value={step.promptLevel}
            onChange={(e) => handleChange('promptLevel', e.target.value)}
            className="w-full xl-input text-sm cursor-pointer"
          >
            {promptHierarchyLevels.map((lvl) => (
              <option key={lvl.value} value={lvl.value}>
                {lvl.label}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
}